// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1pe9H","footer":"ModalError_footer__2RSP5"};